import { GatewayEditFormValues } from 'pages/Gateways/GatewaysEdit/types';
import { Gateway, GatewayPilotModeSchedule } from 'types/embedded/gateway';
import { parseDateInput } from 'utils/date';

// доктрина на бэке по дефолту проставляет для этого поля дату 1970-01-01
// что не позволяет корректно отображать время в соответствии с часовым поясом.
const parseTimeInput = (value: Date | string | null): Date | null =>
  typeof value === 'string'
    ? parseDateInput(value.replace('1970-01-01', new Date().toISOString().split('T')[0]))
    : parseDateInput(value);

const INITIAL_GATEWAY_PILOT_MODE_SCHEDULE: GatewayPilotModeSchedule = {
  schedule: false,
  periodStart: null,
  periodEnd: null,
  timeStart: null,
  timeEnd: null,
};

export const getGatewayFormDefaultValues = (
  record?: Gateway,
  schedule?: GatewayPilotModeSchedule | null,
): GatewayEditFormValues | undefined => {
  if (!record) {
    return undefined;
  }

  return {
    id: record.id,
    name: record.name,
    alias: record.alias,
    externalAlias: record.externalAlias,
    provider: record.provider?.['@id'],
    direction: record.direction?.['@id'],
    status: record.status?.['@id'],
    deactivationReason: record.deactivationReason?.['@id'] ?? null,
    defaultCurrency: record.defaultCurrency?.['@id'],
    supportedCurrencies: record.supportedCurrencies?.map((currency) => currency['@id']),
    autocreateMethod: false,
    requireAmount: record.requireAmount,
    managerVerified: record.managerVerified ?? false,
    pcidss: record.pcidss ?? false,
    pushApi: record.pushApi,
    saveCustomerMethodData: record.saveCustomerMethodData,
    statusRequestEnabled: record.statusRequestEnabled,
    orderExpirationTimeSec: record.orderExpirationTimeSec,
    transactionRequestMaxAttempts: record.transactionRequestMaxAttempts,
    gatewayMethods: (record.gatewayMethods ?? []).map((gatewayMethod) => ({
      ...gatewayMethod,
      method: gatewayMethod.method?.['@id'],
    })),
    method: (record.gatewayMethods ?? []).map((gatewayMethod) => gatewayMethod.method?.['@id']),
    attemptIntervalConfig: record.attemptIntervalConfig?.join(', ') || '',
    gatewayPilotModeSchedule: schedule
      ? {
          id: schedule['@id'] ?? schedule.id,
          schedule: schedule.schedule,
          periodStart: parseDateInput(schedule.periodStart),
          periodEnd: parseDateInput(schedule.periodEnd),
          timeStart: parseTimeInput(schedule.timeStart),
          timeEnd: parseTimeInput(schedule.timeEnd),
        }
      : INITIAL_GATEWAY_PILOT_MODE_SCHEDULE,
  };
};
